import { getValidationDateStringMetaInfo } from './dateHelpers.js';
import { getValidationTimeStringMetaInfo } from './timeHelpers.js';
import type { DSControlledDateTimePickerT } from '../react-desc-prop-types.js';

interface Validators {
  getIsOutOfRangeDay: (day: string) => boolean;
  getIsDisabledDay: (day: string) => boolean;
  getIsDisabledTime: (val: string) => boolean;
}
export const getValidationDateTimeStringMetaInfo = (
  dateString: string,
  timeString: string,
  validators: Validators,
): Partial<DSControlledDateTimePickerT.InternalInputsChangeMetaInfo> => ({
  ...getValidationDateStringMetaInfo(dateString, validators.getIsOutOfRangeDay, validators.getIsDisabledDay),
  ...getValidationTimeStringMetaInfo(timeString, validators.getIsDisabledTime),
});
